import { useEffect } from 'react';
import { useFlipperExperimentBucketQueryLazyQuery, useMembershipQuery } from '../../generated/graphql';

const EXPERIMENT_ID = process.env.REACT_APP_FLIPPER_GUEST_MESSAGING_EXP_ID as string;

export const useGuestMessagingExperiment = () => {
  const [
    callFlipperAssignment,
    { data: flipperData, loading: flipperLoading, called },
  ] = useFlipperExperimentBucketQueryLazyQuery();
  const { data: memberData, loading: memberLoading } = useMembershipQuery();

  const memberId = memberData?.member?.id;
  const variantName = flipperData?.flipperExperimentBucket?.variant_name;

  useEffect(() => {
    if (memberLoading || !memberId || !EXPERIMENT_ID) return;

    callFlipperAssignment({
      variables: {
        flipperExperimentBucketExperimentId: EXPERIMENT_ID,
        flipperExperimentBucketId: memberId,
      },
    });
  }, [memberId, memberLoading, callFlipperAssignment]);

  const loading = !!EXPERIMENT_ID && (memberLoading || !called || flipperLoading);

  if (!variantName) return { loading };

  return {
    loading,
    experimentName: 'Guest List : Address autocollection',
    experimentVariant: variantName,
  };
};
